
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

interface ChartControlsProps {
  title: string;
  description: string;
  showAverageLine: boolean;
  onShowAverageChange: (value: boolean) => void;
  useMetricUnit: boolean;
  unitLabel: string;
  handleUnitToggle: () => void;
  valueKey: string;
  icon?: React.ReactNode; // Add the icon prop
}

export function ChartControls({
  title,
  description,
  showAverageLine,
  onShowAverageChange,
  useMetricUnit,
  unitLabel,
  handleUnitToggle,
  valueKey,
  icon // Add to destructuring
}: ChartControlsProps) {
  const { language } = useLanguage();
  
  return (
    <div className="flex items-start justify-between space-x-4">
      <div className="space-y-1 flex-1">
        <div className="flex items-center gap-2">
          {icon && <span>{icon}</span>} {/* Display the icon if provided */}
          <h3 className="text-xl font-semibold">{title}</h3>
        </div>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex items-center space-x-2">
          <Switch
            id={`show-average-${valueKey}`}
            checked={showAverageLine}
            onCheckedChange={onShowAverageChange}
            className="data-[state=checked]:bg-green-500"
          />
          <label
            htmlFor={`show-average-${valueKey}`}
            className="text-sm font-medium leading-none cursor-pointer"
          >
            {t('statistics.showAverage', language)}
          </label>
        </div>
        <div>
          <Button
            size="sm"
            variant="outline"
            onClick={handleUnitToggle}
            className="text-sm h-9"
          >
            {t('statistics.switchTo', language)} {useMetricUnit ? t('statistics.imperial', language) : t('statistics.metric', language)} ({useMetricUnit ? unitLabel === "g" ? "lb" : "inches" : unitLabel === "lb" ? "g" : "cm"})
          </Button>
        </div>
      </div>
    </div>
  );
}
